import React from 'react'
import Nav from '../components/Nav'
import Footer from '../components/Footer'

const sections = [
  {
    title: 'Information We Collect',
    body: 'We collect information you voluntarily provide when filling out our contact form, including your name, email address, and any message content. We do not collect any information automatically beyond standard server logs.'
  },
  {
    title: 'How We Use Your Information',
    body: 'Information you submit is used solely to respond to your inquiry or to contact you about our services. We do not sell, rent, or share your personal information with third parties for marketing purposes.'
  },
  {
    title: 'Third-Party Services',
    body: 'We use HubSpot to manage contact form submissions. Information submitted through our contact form is stored in HubSpot&rsquo;s systems and subject to their privacy policy. We may also use standard analytics tools to understand site traffic.'
  },
  {
    title: 'Data Retention',
    body: 'We retain contact information only as long as necessary to fulfill the purpose for which it was collected or as required by law. You may request deletion of your data at any time by contacting us.'
  },
  {
    title: 'Your Rights',
    body: 'You have the right to access, correct, or request deletion of any personal information we hold about you. To exercise these rights, please contact us directly at the email below.'
  },
  {
    title: 'Contact Us',
    body: 'If you have any questions about this Privacy Policy, please reach out to us at hello@zeigersoftware.com.'
  }
]

const PrivacyPolicy: React.FC = () => {
  return (
    <div className='flex flex-col min-h-screen bg-bg'>
      <Nav />
      <main className='flex-1 max-w-3xl mx-auto w-full px-4 md:px-8 py-16 md:py-24'>
        {/* <p className='text-[12px] font-bold tracking-[2px] uppercase text-pop mb-3 font-bd'>
          Legal
        </p> */}
        <h1 className='font-hd font-extrabold text-[32px] md:text-[42px] tracking-[-1px] text-ink mb-4'>
          Privacy Policy
        </h1>
        <p className='text-[14px] text-ink3 font-bd mb-12'>
          Last updated: April 23, 2026
        </p>

        <p className='text-[15px] text-ink2 font-bd leading-[1.75] mb-12'>
          Zeiger Software Solutions, LLC (&ldquo;we&rdquo;, &ldquo;us&rdquo;, or &ldquo;our&rdquo;) respects your privacy. This policy
          describes what information we collect, how we use it, and your rights regarding that information.
        </p>

        <div className='flex flex-col gap-10'>
          {sections.map((s) => (
            <div key={s.title}>
              <h2 className='font-hd font-bold text-[18px] text-ink mb-3'>{s.title}</h2>
              <p className='text-[15px] text-ink2 font-bd leading-[1.75]'>{s.body}</p>
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default PrivacyPolicy
